/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { EmailCampaignRestService } from '@gh/builder-shared-data';
import { InitDialogViewService, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { DialogRouteSnapshot } from '@gh/core-ui';
import { GridLayoutService } from '@gh/core-ui-grid';
import { EmailCampaignFilter, EmailCampaignListItem } from './email-campaigns.model';

export type EmailCampaignReportDialogConfig = { campaignId: ID };

@Injectable()
export class EmailCampaignListBusinessService implements InitViewService, InitDialogViewService<EmailCampaignReportDialogConfig> {
  constructor(private emailCampaignRest: EmailCampaignRestService,
              private gridLayouts: GridLayoutService) {
  }

  initView(): any {
    return {
      gridLayout: this.gridLayouts.get('emailCampaigns'),
    };
  }

  initDialogView(route: DialogRouteSnapshot<EmailCampaignReportDialogConfig>): any {
    return {
      report: this.emailCampaignRest.getReport(route.input.campaignId),
    };
  }

  findAllAsDataSource(filter: EmailCampaignFilter): SlicedDataSource<EmailCampaignListItem> {
    return this.emailCampaignRest.findAllAsDataSource(filter);
  }
}
